import { Outlet } from 'react-router-dom'

import SupportMenuTab from '@/features/support/SupportMenuTab'

const SupportPage = () => {
  return (
    <div>
      <SupportMenuTab />
      <Outlet />
    </div>
  )
}

export default SupportPage
